import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import useControlledState from '@quid/react-use-controlled-state';
import { globalTheme, useMixin } from '@clds/component-theme';
import { ColorPickerPopover } from './components';
import { ColorItem } from './components/ColorItem';
import { colorPickerTheme } from './theme';
import { StyledHex } from './components/HexInput';

const FieldWrapper = styled.div`
  display: flex;
`;

const ColorItemWrapper = styled(ColorItem)`
  margin-left: ${globalTheme.spacing.xxs};
`;

/**
 * Readonly `TextField` shown value and visual representation of a color chosen
 * from `ColorPickerPopover` in hex 6 digit hex format or with 8 digits if there's alpha
 * @param initialColor: string
 * @param color: string
 * @param onChange: (color: [string]) => void
 * @param onChangeComplete: (color: [string]) => void
 * @param size?: 'xs' | 'md'
 * @param validationState?: 'error' | 'warning' | 'success' | 'none'
 * @returns {JSX.Element}
 * @constructor
 */
export const ColorField = ({ initialColor, color, onChange: onChangeCustom, onChangeComplete, size = 'xs', id, validationState }) => {
  const [selectedColor, setSelectedColor] = useControlledState(initialColor, color, onChangeCustom);

  return (
    <FieldWrapper>
      <StyledHex type="text" id={id} value={selectedColor} size={size} validationState={validationState} isReadonly />
      <ColorPickerPopover
        color={selectedColor}
        onChange={(color) => setSelectedColor(color)}
        onChangeComplete={onChangeComplete}
        triggeredElement={<ColorItemWrapper value={selectedColor} size={useMixin(colorPickerTheme.field.sizeVariant[size].textField)} />}
      />
    </FieldWrapper>
  );
};

ColorField.propTypes = {
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['xs', 'md']),
};
